<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card :title="`${tag_details.name} Tag ( ${tag_details.status.name} )`">
          <template slot="actions">
            <vs-button v-can="'edit-helper-tag'" v-if="tag_details.status.name !== 'Active'" @click.stop="onClickStatusChange('active')"
              size="small" color="success" type="filled" icon-pack="feather" icon="icon-check">
              Enable Help Tag
            </vs-button>
            <vs-button v-can="'edit-helper-tag'" v-if="tag_details.status.name === 'Active'" @click.stop="onClickStatusChange('in-active')"
              size="small" color="danger" type="filled" icon-pack="feather" icon="icon-x">
              Disable Help Tag
            </vs-button>
          </template>
          <div class="vx-row">
            <div class="vx-col w-1/2">
              <small class="label">Name</small>
              <vs-input class="w-full mb-3" v-model="tag_details.name"></vs-input>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-1/2 md:mb-0">
              <small class="label">Category</small>
              <v-select :clearable="false" placeholder="" v-model="tag_details.category_id" :reduce="option => option.id" label="name"
                :options="category_list" :dir="$vs.rtl ? 'rtl' : 'ltr'" @input="onInputSelectTag()"/>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-1/2">
              <quill-editor v-model="tag_details.data"></quill-editor>
            </div>
          </div>
          <div class="vx-row mt-3">
            <div class="vx-col w-1/2">
              <small class="label">Guide Videos</small>
              <span v-for="(link, index) in tag_details.links" :key="index">
                <div class="vx-row">
                  <div class="vx-col w-4/5">
                    <vs-input class="w-full mb-3" v-model="tag_details.links[index]"></vs-input>
                  </div>
                  <div class="vx-col w-1/5">
                    <vs-button @click="onClickRemoveView(index)" size="small" icon-pack="feather" color="danger"
                      icon="icon-x"></vs-button>
                  </div>
                </div>
              </span>
              <vs-button class="mt-4" size="small" icon-pack="feather" icon="icon-plus" @click.stop="onClickAddVideo">
                add video
              </vs-button>
            </div>
            <div class="vx-col w-1/2">
              <vs-collapse accordion type="border">
                <vs-collapse-item v-for="(link, index) in tag_details.links" :key="index">
                  <div slot="header">
                    Video {{ index + 1 }} - Preview
                  </div>
                  <iframe :src="link" allow="autoplay" frameborder="0" style="border-radius: 10px;"></iframe>
                  <vs-button @click="onClickRemoveView(index)" size="small" icon-pack="feather" color="danger"
                      icon="icon-x"></vs-button>
                </vs-collapse-item>
              </vs-collapse>
            </div>
          </div>
          <div class="vx-row mt-3">
           
          </div>

          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'edit-helper-tag'" button="submit" @click.stop="onClickSave" class="mt-2 ml-auto">Save Changes</vs-button>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import ErrorMessages from "@/mixins/ErrorMessages";
import SuccessMessage from "@/mixins/SuccessMessage";
import vSelect from 'vue-select'
const HelpTagRepository = RepositoryFactory.get('helpTag')

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import { stat } from "fs";

export default {
  name: "HelperTagDetails",
  data() {
    return {
      tag_details: {
        links: []
      },
      help_tag_id: '',
      content: '',
      category_list: []
    }
  },
  components: {
    quillEditor,
    'v-select': vSelect,
  },
  mixins: [ErrorMessages, SuccessMessage],
  mounted() {
    this.help_tag_id = this.$route.params.id
    this.loadInvoiceList()
    this.fetchHelpTagCategories()

    let toolbarElement = document.querySelector('.ql-toolbar');
    if (toolbarElement) {
      let matches = toolbarElement.querySelectorAll('button');
      for (let el of matches) {
        this.showTooltips(el, toolbarElement);
      }
    }
  },
  methods: {
    onClickAddVideo() {
      this.tag_details.links.push('')
    },
    onClickRemoveView(index) {
      this.tag_details.links.splice(index, 1)
    },
    async loadInvoiceList() {
      this.$vs.loading()
      try {
        const { data } = await HelpTagRepository.getHelpTagDetails(this.help_tag_id)
        this.tag_details = data.data;
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async onClickSave() {
      try {
        this.tag_details.links = this.tag_details.links.filter((x) => x.length > 0)
        await HelpTagRepository.updateHelpTag(this.help_tag_id, this.tag_details)
        this.showSuccessMessage('Help tag updated successfully')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async onClickStatusChange(status) {
      try {
        await HelpTagRepository.statusChangeHelpTag(this.help_tag_id, status)
        await this.loadInvoiceList()
        this.showSuccessMessage('Help tag status updated successfully')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    showTooltips(el, toolbarElement) {
      let tooltips = {
        'font': 'Select a font',
        'size': 'Select a font size',
        'header': 'Select the text style',
        'bold': 'Bold',
        'blockquote': 'Blockquote',
        'code-block': 'Code Block',
        'italic': 'Italic',
        'list': 'List',
        'script': 'Script',
        'indent': 'Indent',
        'direction': 'Direction',
        'underline': 'Underline',
        'video': 'Insert a video',
        'strike': 'Strikethrough',
        'color': 'Select a text color',
        'background': 'Select a background color',
        'align': 'Text alignment',
        'link': 'Insert a link',
        'image': 'Insert an image',
        'formula': 'Insert a formula',
        'clean': 'Clear format',
        'add-table': 'Add a new table',
        'table-row': 'Add a row to the selected table',
        'table-column': 'Add a column to the selected table',
        'remove-table': 'Remove selected table',
        'help': 'Show help'
      };
      let tool = el.className.replace('ql-', '');
      console.log(tool);
      if (tooltips[tool]) {
        toolbarElement.querySelector(`button.ql-${tool}`).setAttribute('title', tooltips[tool]);
      }
    },
    async fetchHelpTagCategories() {
      try {
        const { data } = (await HelpTagRepository.getTagCategories(1, 150)).data
        this.category_list = data
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
  },
}
</script>

<style scoped></style>